import type { ButtonProps } from '@coolblue-development/freddy';
import { Button, freddyTheme } from '@coolblue-development/freddy';
import styled from '@emotion/styled';
import { ReactElement, ReactNode } from 'react';

export const StyledButton = ({
  endIcon,
  variant,
  onClick,
  children
}: {
  endIcon: ReactElement;
  variant: 'primary' | 'secondary' | 'action' | 'tertiary';
  onClick: () => void;
  children: ReactNode;
}) => {
  const Styled = styled(Button)<ButtonProps & { onClick: () => void }>(() => ({
    borderColor: freddyTheme.color.border.base,
    boxShadow: 'initial',
    padding: freddyTheme.spacing[200],
    height: freddyTheme.spacing[1000],
    width: '100%',
    justifyContent: 'space-between',
    svg: {
      width: freddyTheme.spacing[300],
      height: freddyTheme.spacing[300]
    },
    ':hover': {
      borderColor: freddyTheme.color.border.base,
      boxShadow: freddyTheme.shadow.subtle
    },
    p: {
      textAlign: 'start' as const,
      paddingLeft: freddyTheme.spacing[100]
    }
  }));

  return (
    <Styled endIcon={endIcon} variant={variant} onClick={onClick}>
      {children}
    </Styled>
  );
};
